import { QueryClientProvider } from 'react-query';

import { appQueryClient } from 'core/query-client/appQueryClient';

const AppQueryProvider = ({ children }) => (
  <QueryClientProvider client={appQueryClient}>{children}</QueryClientProvider>
);

export default AppQueryProvider;
